// Invoice.js
import React from 'react';
import classes from './Invoice1.module.css';

const Invoice = () => {
  const items = Array(2).fill({ name: 'Item goes here', price: 100, qty: 2 });
  const subtotal = items.reduce((acc, item) => acc + item.price * item.qty, 0);
  const tax = 0;
  const total = subtotal + tax;

  return (
    <div className={classes.invoiceWrapper}>
      <div className={classes.invoiceContainer}>
        <div className={classes.invoiceTop}>
        <div className={classes.invoiceTopBar}></div>
             <div className={classes.logoArea}>
              <div className={classes.logoShape}></div>
              <div>
                <div className={classes.logoText}>SCIENCE</div>
                <div className={classes.logoSubtext}>INSTITUTION</div>
              </div>
            </div>
            </div>
        <header className={classes.invoiceHeader}>
          <div className={classes.leftHeader}>
       
            <div className={classes.invoiceTitle}>Invoice</div>
            <p className={classes.invoiceNumber}>N° 123</p>
            <p className={classes.invoiceDate}>MM/DD/YEAR</p>
          </div>
          <div className={classes.rightHeader}>
            <p  className={classes.invoiceNumber1}><strong>Invoice to:</strong></p>
            <p className={classes.invoiceNumber1}> Jon Doe</p>
            <p className={classes.invoiceNumber1}>Science Street nº3</p>
            <p className={classes.invoiceNumber1}>Town</p>
          </div>
        </header>

        <table className={classes.invoiceTable}>
          <thead>
            <tr>
              <th>PRODUCT</th>
              <th></th>
              <th></th>
              <th>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td></td>
                <td></td>
                <td>€{(item.price * item.qty).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className={classes.infwrap}>
        <div className={classes.paymentInfo}>
          <p><strong>Payment information</strong></p>
          <p> Account Number: 1234 5678 9101 01</p>
          <p>Account Name: Jane Doe</p>
        </div>

        <div className={classes.summaryBox}>
          {/* <div className={classes.summaryRow}><span>SUBTOTAL</span><span>€{subtotal.toFixed(2)}</span></div> */}
          {/* <div className={classes.summaryRow}><span>TAX</span><span>€{tax.toFixed(2)}</span></div> */}
          <div className={classes.totalRow}><span>TOTAL</span><span>€{total.toFixed(2)}</span></div>
        </div>
        </div>

        <footer className={classes.footer}>
          <span>+123 456 789 123</span>
          <span>www.science.com</span>
          <span>science street nº3, 0000, Town</span>
        </footer>
      </div>
    </div>
  );
};

export default Invoice;
